import { Translatable } from './translatable';

import * as _ from 'lodash';

import { FileRef } from './file-ref';
import { CustomField } from './custom-field';
import { MetaTag } from './meta-tag';

export class Page extends Translatable {
  public static readonly CLASS_NAME = 'Page';
  public static readonly TITLE_KEY = 'title';
  public static readonly SUBTITLE_KEY = 'subtitle';
  public static readonly IMAGE_KEY = 'image';
  public static readonly CONTENT_KEY = 'content';
  public static readonly ELEMENTS_KEY = 'elements';
  public static readonly HEADLINE_KEY = 'headline';
  public static readonly NAME_KEY = 'name';
  public static readonly PERMALINK_KEY = 'permalink';
  public static readonly SORT_ORDER_KEY = 'sortOrder';
  public static readonly ENABLED_KEY = 'enabled';
  public static readonly CUSTOM_FIELDS_KEY = 'customFields';
  public static readonly META_TAGS_KEY = 'metaTags';

  public static readonly HOME_PERMALINK = 'home';
  public static readonly SEARCH_PERMALINK = 'search';
  public static readonly ABOUT_US_PERMALINK = 'about-us';
  public static readonly CAREER_PERMALINK = 'career';
  public static readonly LOCATIONS_PERMALINK = 'locations';
  public static readonly EXPERTISE_PERMALINK = 'expertise';
  public static readonly OUR_EXPERTISE_PERMALINK = 'our-expertise';
  public static readonly OUR_STRENGTH_PERMALINK = 'our-strength';
  public static readonly OUR_NETWORK_PERMALINK = 'our-network';
  public static readonly CONTACT_US_PERMALINK = 'contact-us';

  constructor() {
    super(Page.CLASS_NAME);
    this.enabled = true;
  }

  // ===============================================================================================
  // Translations
  // ===============================================================================================

  public getName(lang: string): string {
    return this.getTranslation(Page.NAME_KEY, lang);
  }

  public setName(name: string, lang: string) {
    this.setTranslation(Page.NAME_KEY, name, lang);
  }

  public getHeadline(lang: string): string {
    return this.getTranslation(Page.HEADLINE_KEY, lang);
  }

  public setHeadline(headline: string, lang: string) {
    this.setTranslation(Page.HEADLINE_KEY, headline, lang);
  }

  public getTitle(lang: string): string {
    return this.getTranslation(Page.TITLE_KEY, lang);
  }

  public setTitle(title: string, lang: string) {
    this.setTranslation(Page.TITLE_KEY, title, lang);
  }

  public getSubtitle(lang: string): string {
    return this.getTranslation(Page.SUBTITLE_KEY, lang);
  }

  public setSubtitle(subtitle: string, lang: string) {
    this.setTranslation(Page.SUBTITLE_KEY, subtitle, lang);
  }

  public getContent(lang: string): string {
    return this.getTranslation(Page.CONTENT_KEY, lang);
  }

  public setContent(content: string, lang: string) {
    this.setTranslation(Page.CONTENT_KEY, content, lang);
  }

  public getMetaTags(lang: string): MetaTag[] {
    return this.getTranslation(Page.META_TAGS_KEY, lang);
  }

  public setMetaTags(metaTags: MetaTag[], lang: string) {
    this.setTranslation(Page.META_TAGS_KEY, metaTags, lang);
  }

  public getImage(lang: string): FileRef {
    return this.getTranslation(Page.IMAGE_KEY, lang);
  }

  public setImage(image: FileRef, lang: string) {
    this.setTranslation(Page.IMAGE_KEY, image, lang);
  }

  // ===============================================================================================
  // Accessors
  // ===============================================================================================

  public get customFields(): CustomField[] {
    return this.get(Page.CUSTOM_FIELDS_KEY);
  }

  public set customFields(customFields: CustomField[]) {
    this.set(Page.CUSTOM_FIELDS_KEY, customFields);
  }

  public get permalink(): string {
    return this.get(Page.PERMALINK_KEY);
  }

  public set permalink(permalink: string) {
    this.set(Page.PERMALINK_KEY, permalink);
  }

  public get sortOrder(): number {
    return this.get(Page.SORT_ORDER_KEY);
  }

  public set sortOrder(sortOrder: number) {
    this.set(Page.SORT_ORDER_KEY, sortOrder);
  }

  public get enabled(): boolean {
    return this.get(Page.ENABLED_KEY);
  }

  public set enabled(enabled: boolean) {
    this.set(Page.ENABLED_KEY, enabled);
  }
}

Parse.Object.registerSubclass(Page.CLASS_NAME, Page);



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/data/page.ts